/**
 * Wishlist voor Prestige-thema
 * Slaat producten op in localStorage (per browser, geen account nodig).
 */
(function () {
  const STORAGE_KEY = 'prestige-wishlist';

  function getWishlist() {
    try {
      const raw = window.localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(items) {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    document.dispatchEvent(
      new CustomEvent('wishlist:updated', { detail: { items } })
    );
  }

  function isInWishlist(id) {
    return getWishlist().some((item) => String(item.id) === String(id));
  }

  function addToWishlist(product) {
    const items = getWishlist();
    if (!items.some((item) => String(item.id) === String(product.id))) {
      items.push(product);
      saveWishlist(items);
    }
  }

  function removeFromWishlist(id) {
    const items = getWishlist().filter(
      (item) => String(item.id) !== String(id)
    );
    saveWishlist(items);
  }

  function toggleWishlist(product) {
    if (isInWishlist(product.id)) {
      removeFromWishlist(product.id);
      return false;
    }
    addToWishlist(product);
    return true;
  }

  function updateButtonStates() {
    document.querySelectorAll('[data-wishlist-button]').forEach((btn) => {
      const id = btn.getAttribute('data-product-id');
      btn.classList.toggle('is-active', isInWishlist(id));
      btn.setAttribute('aria-pressed', isInWishlist(id) ? 'true' : 'false');
    });

    const count = getWishlist().length;

    document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
      el.textContent = count;
    });

    document.querySelectorAll('[data-wishlist-dot]').forEach((el) => {
      el.classList.toggle('is-visible', count > 0);
    });
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-wishlist-button]');
    if (!btn) return;
    e.preventDefault();

    const product = {
      id: btn.getAttribute('data-product-id'),
      handle: btn.getAttribute('data-product-handle'),
      title: btn.getAttribute('data-product-title'),
      image: btn.getAttribute('data-product-image'),
      price: btn.getAttribute('data-product-price'),
      url: btn.getAttribute('data-product-url'),
    };

    toggleWishlist(product);
    updateButtonStates();
  });

  document.addEventListener('DOMContentLoaded', updateButtonStates);
  document.addEventListener('wishlist:updated', updateButtonStates);

  window.PrestigeWishlist = {
    get: getWishlist,
    isInWishlist,
    remove: removeFromWishlist,
  };
})();
